<template>
    <div id="conteudoHistoricoLicitacao">
        <b-table :fields="fields" :items="items" :busy="tableBusy" :current-page="currentPage" hover no-border-collapse
            sort-by="" :sort-desc="true" striped stacked="md" show-empty>
            <template #empty>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
                <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                </div>
            </template>
        </b-table>
        <table-pagination v-if="totalRows > 10" :total-rows="totalRows" :per-page="10" @pageChange="pageChange" />
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

import ldiService from '@/services/licitacoes/ldiService'
import { TableField } from '@/types/table-field'
import { fieldsHistoricoLicitacao } from '@/types/licitacoes/ldi/fields-historico-licitacao'
import { HistoricoLicitacao } from '@/types/licitacoes/ldi/historico-licitacao'
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";

const CompProps = Vue.extend({
    name: 'HistoricoLicitacao',
    components: { TablePagination },
    props: {
        idLicitacao: {
            type: Number,
            required: true
        }
    }
})

@Component
export default class DetalhesHistorico extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = fieldsHistoricoLicitacao
    items: HistoricoLicitacao[] = []

    //table-related
    currentPage = 1
    pageSize = 10
    totalRows = 0
    tableBusy = false

    async mounted() {
        this.loadData()
    }

    async pageChange(value) {
        this.currentPage = value;
        await this.loadData();
    }
    async loadData(): Promise<void> {
        try {
            this.tableBusy = true;
            const response = await ldiService.buscarHistorico(this.idLicitacao, this.currentPage, this.pageSize)
            if (response) {
                this.items = response.logs.map(l => {
                    const item = Object.assign(new HistoricoLicitacao(), l)
                    item.tratarDadosDaAPI()
                    return item
                })
                this.totalRows = response.totalRows
            } else {
                this.$toast.error('Erro ao consultar o histórico de licitações.');
            }
        } finally {
            this.tableBusy = false;
        }
    }
}
</script>

<style></style>